import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Observable } from 'rxjs';
// import { InventoryService } from './inventory.service';
declare var $: any;

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { locateHostElement } from '@angular/core/src/render3/instructions';
const moment = _rollupMoment || _moment;

const distinctCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CATNAME === x.CATNAME) === idx);
const distinctSubCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.SUBCATNAME === x.SUBCATNAME) === idx);
const distinctPartType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.PARTTYPENAME === x.PARTTYPENAME) === idx);
const distinctUOM = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.UOMTYPENAME === x.UOMTYPENAME) === idx);

@Component({
	selector: 'JobCard',
	templateUrl: './jobCardApproval.component.html',
})
export class jobCardApprovalComponent {
  public distinctCat: any[];
  public distinctSubCat: any[];
  public distinctPartType: any[];
  public distinctUOM: any[];
  search: any;
  prjId: any;
  showLoader: boolean;
  jobCardList: any;
  vehMaintUOMList: any;
  priceModal: any;
  uomModal: any;
  serviceModal: any;
  partModal: any;
  quantityModal: any;
  upQuantityModal: any;
  saveSuccess = false;
  errorInSuccess = false;
  userId: any;
  respMsg: any;
  selectedRow: number;
  maintMstDataNotFound = false;
  vehiclesCatogeryList: any;
  vehiclesTypeList: any;
  vehCotegaryId: any;
  vehTypeId: any;
  partCode: any;
  imgLoaderPath: any;
  entityCodeLoaderDiv = false;
  isVehicleUpdtbtn = false;
  newPartCode: any;
  isBtnSave = false;
  categoryList: any;
  subCategoryList: any;
  partTypeList: any;

  partNameList:any;
  vanderList:any;

  dateRangeModal: any

  categoryId: any;
  partModalData: any;
  typeModal: any;
  categoryModal: any;
  subCategoryModal: any;
  newCategory: any;
  categoryCreateMsg: any;
  categorySuccess = false;
  categoryError = false;
  newVendor: any;

  newSubCategory:any;

  newvendorName :any;
  subCatError = false;
  subCatSuccess = false;
  newPartTypeModal: any;
  partSuccess = false;
  partError = false;
  itemToUpdate: any;
  upCategoryModal: any;
  upTypeModal: any;
  upPartModal: any;
  upUomModal: any;
  upPriceModal: any;
  upSubCategoryModal: any;
  CATNAME: string;
  partCodeModal: any;
  syncing: any;
  public roleList: any;
  loaderClass: any;
  vTypeModel: any;
  vSubCategoryModal: any;
  vCategoryModal: any;

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  newQuantityModal: any;
  newPriceModal: any;
  public wrongQuantity: boolean = false;
  vendorModal: any;
  invoiceModal: any;
  inwardModal: any;
  invoiceDateModal: any;
  userName: string;
  PARTNAME: any;
  ENTRYDATE: any;
  ENTRYBY: any;
  vendorId: any;
  startDate: string;
  endDate: typeof _moment;
  updateStock: { id: number; name: string; }[];
  public one = false ;
  public two = false ;
  vVenderName: any;
  U_Invoice: any;
  updateStockValue: any;
  partsDetailsList: Object;
  partsHistoryList: Object;
  totalPrice: any;
  todayusedPrice: any;
  ZeroStock: any;
  todayUsedStock: any;
  remaingStock: any;
  defaultStartDate: string;
  defaultEndDate: string;
  selectedBillType: any;
  challanNumber: any;
  newBillNumber: any;
  newBillNumberCheck: boolean;
  ChallanvalueCheck: boolean;
  selectedBillTypeCheck: boolean;
  NewChallanmodal: any;
  challanOrInvoice: any;
  newChallan: any;
  partId: any;
  partMasterId: any;
  mainPartId: any;
  tsStartdate: string;
  tsEndDate: string;
  TsTotalAmount: any;
  TsTotalParts: any;
  purchaseType: any;
  cashCreditModal: any;
  jobCardDetailsList: any;
	status: number;
	titleData: string;
	successMsg: string;
  jobCardPartNameModal: any;
  ReturnQuantityModal: any;
  returnPartId: any;
  returnValueCheck: boolean;
  returnPartMasterId: any;
  saveCheck: any;

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  vUomModel: any;
  selectedCatID: any;
  selectedSubCatID: any;
  selectedUomID: any;
  selectedTypemID: any;
  oneCatID: any;
  oneSubCatID: any;
  oneUomID: any;
  oneTypeID: any;
  newSubCategoryList: any;
 

  private loadProducts(): void {
    this.gridinventory = process(this.jobCardList, { group: this.groups });
  }
  public gridinventory: GridDataResult;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    public router: Router,
    // public _inventory: InventoryService,
    
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    var date = new Date();
    this.selectedBillType = '';
    this.selectedBillTypeCheck = false;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
   
    this.dateRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } };



//    this.purchaseType = [
//       { id: 2, name: 'Cash' },
//       { id: 1, name: 'Credit' } 
//   ];








  }

	/*
   * Get All Vehicle Master List
  */

  getJobCardDetails() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'maintenance/getJobCardDetails?prjid=' + this.prjId).subscribe((data) => {
      this.jobCardList = data;



      console.log('245',this.jobCardList);
      
      
      if (this.jobCardList.length > 0) {
        this.gridinventory = process(this.jobCardList, this.state);
        this.distinctCat = distinctCat(this.jobCardList);
        this.distinctSubCat = distinctSubCat(this.jobCardList);
        this.distinctPartType = distinctPartType(this.jobCardList);
        this.distinctUOM = distinctUOM(this.jobCardList);
        this.maintMstDataNotFound = false;
        this.loaderService.display(false);
      } else {
        this.maintMstDataNotFound = true;
        this.loaderService.display(false);
        this.gridinventory = process(this.jobCardList, this.state);
      }
    });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridinventory = process(this.jobCardList, this.state);
    if (state && state.group) {
      this.gridinventory = process(this.jobCardList, this.state);
    }
  }




  downloadExcelFile(vehicleInfoData,filename) {
    const ws_name = 'VehicleInfo';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehicleInfoData);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), filename);
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }

	

 

  














  ngOnInit() {

    this.prjId = this.auth.getAuthentication().projectId;
    this.userId = this.auth.getAuthentication().id;
    this.userName = this.auth.getAuthentication().userName;
    this.getJobCardDetails();


  }







  onDateRangeChanged(dateRange){

    if (dateRange.beginDate.day > 0) {
      this.defaultStartDate = dateRange.beginDate.year + "-" + dateRange.beginDate.month + "-" + dateRange.beginDate.day
      this.defaultEndDate = dateRange.endDate.year + "-" + dateRange.endDate.month + "-" + dateRange.endDate.day
     
      
    } else if (dateRange.beginDate.day == 0) {
      this.defaultStartDate = this.defaultStartDate
      this.defaultEndDate = this.defaultEndDate
   
     
    }

  }





  onTSDateRangeChanged(dateRange){

    if (dateRange.beginDate.day > 0) {
      this.defaultStartDate = dateRange.beginDate.year + "-" + dateRange.beginDate.month + "-" + dateRange.beginDate.day
      this.defaultEndDate = dateRange.endDate.year + "-" + dateRange.endDate.month + "-" + dateRange.endDate.day
      
      
    } else if (dateRange.beginDate.day == 0) {
      this.defaultStartDate = this.defaultStartDate
      this.defaultEndDate = this.defaultEndDate
    
     
    }



  }


  openJobCardModal(dataPart){


 
    


    var partid = dataPart.ID



    this.http.get(environment.apiUrl + 'maintenance/jobCardDetailsList?partid='+partid).subscribe((data) => {
     this.jobCardDetailsList = data ;
 
    });




    // this.http.get(environment.apiUrl + 'maintenance/PartDetailsHisroryList?partid='+partid).subscribe((data) => {
    //   this.partsHistoryList = data ;

    //  });
     
    

    $('#partItemModal').modal('show');
                 

  }



  approvedJobCard(data){

   console.log(data,392);
   



	var status=data.ID


	// if(status=="Active"){
	// 	this.status=0 
	// 	this.titleData="Are you sure to Approved this Job Card?"
	// 	this.successMsg="User Inactive successfully."
	// }else{
	// 	this.status=1 
	// 	this.titleData="Are you sure to Active this user?"
	// 	this.successMsg="User Active successfully."
	// }

	this.titleData="Are you sure to Approved this Job Card?"

	
	var dataJason={
		"ID":data.ID,
		
	}
	  
	Swal({
		title: this.titleData, 
		type: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Yes, Approved it!'
	  }).then((result) => {
		if (result.value) { 
		  this.http.post(environment.apiUrl + 'maintenance/approvedJobCard', dataJason).subscribe(data =>{ 
			  var response:any
			  response = data 
			  var status = response.status 
			  if (status == "OK") { 
				  this.getJobCardDetails();
				Swal( 
				  this.successMsg,
				  'success'
				  ) 
				  } else 
				  { 
				  Swal(
				  "Error During user Active/Inactive operation!",
				  'error'
				  ) 
			  }
			});
		}
	  })
  }


  jobCardReturnParts(data){


 

    this.jobCardPartNameModal = data.PARTNAME
    this.quantityModal = data.QUANTITY
    this.returnPartId = data.pid
    this.returnPartMasterId = data.part_number

    this.returnValueCheck =   false




   $('#jobCardModal').modal('show');

  }



  saveJobCardReturnItem(){



     if(this.quantityModal >this.ReturnQuantityModal){


      console.log('true');
      

      if (this.ReturnQuantityModal>0) {
         
        this.saveCheck = true ;
        
      }else{

        this.returnValueCheck = true


        return 
      

      }

     
     }else{

      console.log('esle');
      this.returnValueCheck = true


      return 
     }



     console.log('data save ');



       var dataJason={
        "returnQty": this.ReturnQuantityModal,
        "returnPartId":this.returnPartId,
        'returnPartMasterId':this.returnPartMasterId
        
      }

    this.http.post(environment.apiUrl + "maintenance/saveJobCardReturnItem", dataJason).subscribe(data =>{ 
      var response:any
      response = data ;

      setTimeout(() => {
        $('#jobCardModal').modal('hide');

        this.getJobCardDetails();
        
      }, 2000);

   
   
    });


  }

 










     




}



// WEBPACK FOOTER //
// ./src/app/maintenance/vehicleMaintenance/vehicleMnt/jobCardApproval.component.ts